export default "__VITE_ASSET__BETTj2C7__"